import { render, staticRenderFns } from "./FeaturedCreations.vue?vue&type=template&id=5c99e53d&scoped=true"
import script from "./FeaturedCreations.vue?vue&type=script&lang=js"
export * from "./FeaturedCreations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99e53d",
  null
  
)

export default component.exports